import script from "./ruleTemp.vue?vue&type=script&setup=true&lang=js"
export * from "./ruleTemp.vue?vue&type=script&setup=true&lang=js"

import "./ruleTemp.vue?vue&type=style&index=0&id=0be492a9&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0be492a9"]])

export default __exports__